import { render } from "./cropper.vue?vue&type=template&id=ee970d4a&scoped=true"
import script from "./cropper.vue?vue&type=script&lang=js"
export * from "./cropper.vue?vue&type=script&lang=js"

import "./cropper.vue?vue&type=style&index=0&id=ee970d4a&lang=less&scoped=true"

import exportComponent from "D:\\aj项目\\code\\清洁能源中文预登记\\ceec_-visitor_-cn\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee970d4a"]])

export default __exports__